<dx-popup
  [visible]="true"
  [showTitle]="true"
  [title]="'Add new MyCompetence Training'"
  [width]="500"
  [height]="200"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  (onHidden)="cancel()"
>
  <div>
    <dx-text-box
      [(value)]="courseId"
      [placeholder]="'Enter ID here'"
      [showClearButton]="true"
    ></dx-text-box>
    <br>
    <div class="popup-buttons">
      <dx-button 
        [text]="'COMMON.CANCEL' | translate"
        type="danger" 
        (onClick)="cancel()"
      ></dx-button>
      <dx-button 
        [text]="'COMMON.SAVE' | translate"
        type="normal" 
        (onClick)="submit()"
      ></dx-button>
    </div>
  </div>
</dx-popup>